/**
 * The offline / queued state.
 *
 * A cloakroom is a basement. The guest must always be able to tell whether what
 * they are looking at is live or remembered, and whether anything is waiting to
 * sync — silence here reads as "it worked", which is the one thing it must not do.
 */
export default function OfflineBanner(props: {
  online: boolean
  queuedCount: number
  /** Set when the visible state came from cache rather than the network. */
  cacheAge?: string | null
  /** Set right after a check-in was queued offline rather than sent. */
  savedLocally?: boolean
}) {
  const visible = () => !props.online || props.queuedCount > 0 || !!props.cacheAge || !!props.savedLocally

  return (
    <div hidden={!visible()} class="rounded-xl bg-amber-400/10 border border-amber-400/30 p-3">
      <p class="text-xs text-amber-200">
        {props.online
          ? props.savedLocally
            ? 'Saved on this device — it will send automatically when you are back online.'
            : 'Showing saved data.'
          : 'You are offline. Check-ins are saved on this device and sent when signal returns.'}
      </p>
      {props.cacheAge && <p class="text-[11px] text-amber-300/70 mt-1">Last updated {props.cacheAge}.</p>}
      {props.queuedCount > 0 && (
        <p class="text-[11px] text-amber-300/70 mt-1">
          {props.queuedCount} check-in{props.queuedCount === 1 ? '' : 's'} waiting to sync
        </p>
      )}
    </div>
  )
}
